import React, { Component } from "react";
import { debounce } from "util";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import { Page, StyledButton, Fab } from "components/support";
import { colors } from "assets";

import Filter from "./filter";
import DataTable from "./data-table";
import Totals from "./totals";

export default class ProductView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { filter, loading, company } = viewModel;

    const hasManageSellable = company.features.includes("manage_sellable");

    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Produtos
            </Typography>
          </Col>

          {hasManageSellable && (
            <Col style={{ marginBottom: 20 }}>
              <StyledButton
                accent
                style={{ margin: 10 }}
                label="Importação em Lotes"
                onClick={() => presenter.onRequestBatchImport()}
              />

              <StyledButton
                accent
                style={{ margin: 10 }}
                label="Ajuste de Inventário"
                onTouchTap={() => presenter.onRequestInventoryAdjust()}
              />

              <StyledButton
                accent
                style={{ margin: 10 }}
                label="Modificar Estoque"
                onTouchTap={() => presenter.onRequestEditStock()}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <Filter
              onFilter={debounce(filter => presenter.setFilter(filter), 500)}
              loading={loading}
            />
          </Col>
        </Row>
        <Row>
          <Col className="product__content full-height" xs={12}>
            <Totals filter={filter} loading={loading} />
          </Col>
          <Col lg={12} xs={12}>
            <DataTable
              filter={filter}
              loading={loading}
              hasManageSellable={hasManageSellable}
              setLoading={presenter.setLoading}
            />
          </Col>
        </Row>
        {hasManageSellable && (
          <Fab
            backgroundColor={colors.button.secondary}
            onClick={() => presenter.onCreate()}
            icon="add"
          />
        )}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/view.jsx